import React, { useState, useEffect } from "react";

import { clearConsultAnswersJSON } from "~/visits/utils/visitCookies";

import PropTypes from "prop-types";

import withStyles from "@material-ui/core/styles/withStyles";
import { useTheme } from "@mui/material/styles";

import useMediaQuery from "@material-ui/core/useMediaQuery";

import Button from "../../material-dashboard/components/CustomButtons/Button.jsx";

import GridContainer from "../../material-dashboard/components/Grid/GridContainer.jsx";
import GridItem from "../../material-dashboard/components/Grid/GridItem.jsx";
import Card from "../../material-dashboard/components/Card/Card.jsx";
import CardBody from "../../material-dashboard/components/Card/CardBody.jsx";

import consultationStyles from "../styles/consultationStyles.js";

import { bugsnagClient } from "~/shared/utils/errorHandling.js";

const SubscriptionFollowUpVisitComplete = (props) => {
  const { classes } = props;
  clearConsultAnswersJSON();

  const theme = useTheme();
  const fullScreenPersonaDialog = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div
      //   className={classes.container}
      style={{ backgroundColor: "#3F3F82" }}
    >
      <GridContainer justifyContent="center">
        <Card className={classes.cardConsultation}>
          <CardBody
            className={classes.paymentCardBody}
            style={{
              //   height: "1200px",
              border: "5px solid red",
              justifyContent: "center",
            }}
          >
            <GridItem xs={12} sm={12} md={10}>
              <h3
                style={{
                  // color: "#FFFFFF",
                  fontFamily: "Spectral-SemiBold",
                  fontSize: "32px",
                }}
              >
                Follow-Up Complete
              </h3>
              <p
                style={{
                  // color: "#FFFFFF",
                  fontFamily: "BasisGrotesquePro-Regular",
                  fontSize: "18px",
                  lineHeight: "26px",
                  // letterSpacing: "-0.21px"
                }}
              >
                Your follow-up visits has been received. We'll email you as soon
                as your provider has reviewed your visit. <br />
                <br />
                <strong>Some helpful links:</strong>
                <br /> <a href="/treatment/">Treatment Plans</a>
                <br />{" "}
                <a href="/guides/">
                  Kick Guides To Living Confidently and Energetically
                </a>
                <br />{" "}
                <a href="/me/messages/care/">Secure Message Your Care Team </a>
                <br />
                {/* <br /> <a href="/me/">Back to My Account -></a> */}
                <Button
                  // disabled={this.state.disableButton}
                  onClick={() => {
                    // this.setState({ disableButton: true });
                    window.location.href = "/me/portal/";
                  }}
                  style={{
                    display: "block",
                    backgroundColor: "#F25930",
                    margin: "30px auto",
                    width: "300px",
                  }}
                >
                  Back to My Account ->
                </Button>
              </p>
            </GridItem>
          </CardBody>
        </Card>
      </GridContainer>
    </div>
  );
};

export default withStyles(consultationStyles)(
  SubscriptionFollowUpVisitComplete
);
